/* eslint-disable camelcase */
/* eslint-disable import/prefer-default-export */

import { get, post } from '../API';

export const listSubscriptions = async ({ limit = 100, page = 0 }) => {
  const response = await get(
    '/fd-subscriptions',
    {
      limit,
      page,
    },
    {},
    'fieldDelineation'
  );
  // console.log('response', response);
  return response;
};

export const createSubscription = async ({ name, props }) => {
  const payload = {
    name,
    props,
  };

  const response = await post(
    '/fd-subscriptions',
    payload,
    {},
    'fieldDelineation'
  );

  return response;
};

export const createSubscriptionFdData = async ({
  subscriptionId,
  userId,
  token,
  apiType,
  props,
  datalayerType,
}) => {
  const payload = {
    userId,
    token,
    apiType,
    props,
    datalayerType,
  };

  const response = await post(
    `/fd-subscriptions/${subscriptionId}/fdData`,
    payload,
    {},
    'fieldDelineation'
  );

  return response;
};

export const getSubscriptionFdData = async ({
  subscriptionId,
  page = 0,
  limit = 10,
}) => {
  const response = await get(
    `/fd-subscriptions/${subscriptionId}/fdData`,
    {
      page,
      limit,
    },
    {},
    'fieldDelineation'
  );

  // console.log('getSubscriptionFdDataResponse----', response);

  return response;
};

export const getActiveTokenAndCredits = async () => {
  const response = await get(`/user/credits`, {}, {}, 'fieldDelineation');

  return response;
};

export const getSubscriptionDataById = async ({ subscriptionId }) => {
  const response = await get(
    `/fd-subscriptions/${subscriptionId}/Subdata`,
    {},
    {},
    'fieldDelineation'
  );

  return response;
};

export const getTokenData = async () => {
  const response = await get('/tokens', {}, {}, 'fieldDelineation');
  // console.log('getToken API level##################################', response);
  return response;
};
